import React, { useState } from "react";
import axios from "axios";
import logoImg from "./logo.png";

export default function Login({ onLogin, notice }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotMsg, setForgotMsg] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);

  const handleSubmit = async () => {
    setError("");
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("username", email);
      params.append("password", password);

      const res = await axios.post("/auth/login", params, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });

      const token = res.data.access_token;
      localStorage.setItem("fox_token", token);

      const me = await axios.get("/auth/me", {
        headers: { Authorization: `Bearer ${token}` },
      });

      onLogin(me.data);
    } catch (err) {
      setError("Invalid email or password.");
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    setForgotLoading(true);
    setForgotMsg("");
    try {
      await axios.post("/auth/forgot-password", { email: forgotEmail });
      setForgotMsg("If an account with that email exists, a reset link has been sent.");
    } catch {
      setForgotMsg("Something went wrong. Please try again.");
    } finally {
      setForgotLoading(false);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--bg)",
        fontFamily: "var(--font)",
      }}
    >
      <div
        style={{
          width: 380,
          background: "var(--bg2)",
          border: "0.5px solid var(--border2)",
          borderRadius: "var(--radius-xl)",
          boxShadow: "0 8px 40px rgba(0,0,0,0.10)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: 4,
            background:
              "linear-gradient(90deg, var(--bgfc) 0%, var(--nsa) 50%, var(--pfc) 100%)",
          }}
        />

        <div style={{ padding: "36px 36px 32px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 10,
              marginBottom: 32,
            }}
          >
            <img
              src={logoImg}
              alt="FOX"
              style={{ height: 72, width: "auto", objectFit: "contain" }}
            />
            <div style={{ textAlign: "center" }}>
              <div
                style={{
                  fontSize: 28,
                  fontWeight: 700,
                  letterSpacing: "-0.03em",
                  color: "var(--text)",
                  lineHeight: 1,
                  marginBottom: 6,
                }}
              >
                FOX
              </div>
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 500,
                  color: "var(--text3)",
                  textTransform: "uppercase",
                  letterSpacing: "0.12em",
                }}
              >
                Fleet &amp; Operations eXchange
              </div>
            </div>
          </div>

          {notice && !error && (
            <div
              style={{
                fontSize: 12,
                color: "var(--text2)",
                background: "var(--bg3)",
                border: "0.5px solid var(--border2)",
                borderRadius: "var(--radius)",
                padding: "8px 12px",
                marginBottom: 16,
              }}
            >
              {notice}
            </div>
          )}

          {error && (
            <div
              style={{
                fontSize: 12,
                color: "var(--red)",
                background: "var(--red-dim)",
                border: "0.5px solid rgba(248,81,73,0.25)",
                borderRadius: "var(--radius)",
                padding: "8px 12px",
                marginBottom: 16,
              }}
            >
              {error}
            </div>
          )}

          <div style={{ marginBottom: 14 }}>
            <label
              style={{
                display: "block",
                fontSize: 11,
                fontWeight: 600,
                color: "var(--text3)",
                textTransform: "uppercase",
                letterSpacing: "0.07em",
                marginBottom: 6,
              }}
            >
              Email
            </label>
            <input
              type="email"
              placeholder="you@flymankato.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
              style={{
                width: "100%",
                height: 40,
                padding: "0 14px",
                background: "var(--bg3)",
                border: "0.5px solid var(--border2)",
                borderRadius: "var(--radius)",
                color: "var(--text)",
                fontFamily: "var(--font)",
                fontSize: 14,
                outline: "none",
                boxSizing: "border-box",
              }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label
              style={{
                display: "block",
                fontSize: 11,
                fontWeight: 600,
                color: "var(--text3)",
                textTransform: "uppercase",
                letterSpacing: "0.07em",
                marginBottom: 6,
              }}
            >
              Password
            </label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
              style={{
                width: "100%",
                height: 40,
                padding: "0 14px",
                background: "var(--bg3)",
                border: "0.5px solid var(--border2)",
                borderRadius: "var(--radius)",
                color: "var(--text)",
                fontFamily: "var(--font)",
                fontSize: 14,
                outline: "none",
                boxSizing: "border-box",
              }}
            />
          </div>

          <button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              width: "100%",
              height: 42,
              background: "var(--blue)",
              border: "none",
              borderRadius: "var(--radius)",
              color: "#fff",
              fontFamily: "var(--font)",
              fontSize: 14,
              fontWeight: 600,
              letterSpacing: "0.02em",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.7 : 1,
              transition: "opacity 0.15s",
            }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>

          {!showForgot ? (
            <button
              type="button"
              onClick={() => {
                setShowForgot(true);
                setForgotEmail(email);
                setForgotMsg("");
              }}
              style={{
                width: "100%",
                marginTop: 10,
                background: "none",
                border: "none",
                color: "var(--ink-blue)",
                fontSize: 13,
                cursor: "pointer",
              }}
            >
              Forgot password?
            </button>
          ) : (
            <div style={{ marginTop: 16 }}>
              <input
                type="email"
                placeholder="Enter your email"
                value={forgotEmail}
                onChange={(e) => setForgotEmail(e.target.value)}
                style={{
                  width: "100%",
                  height: 38,
                  padding: "0 12px",
                  marginBottom: 8,
                  background: "var(--bg3)",
                  border: "0.5px solid var(--border2)",
                  borderRadius: "var(--radius)",
                  color: "var(--text)",
                  fontFamily: "var(--font)",
                  fontSize: 14,
                  boxSizing: "border-box",
                }}
              />
              <button
                type="button"
                onClick={handleForgotPassword}
                disabled={forgotLoading}
                style={{
                  width: "100%",
                  height: 42,
                  background: "var(--blue)",
                  border: "none",
                  borderRadius: "var(--radius)",
                  color: "#fff",
                  fontFamily: "var(--font)",
                  fontSize: 14,
                  fontWeight: 600,
                  letterSpacing: "0.02em",
                  cursor: forgotLoading ? "not-allowed" : "pointer",
                  opacity: forgotLoading ? 0.7 : 1,
                  transition: "opacity 0.15s",
                }}
              >
                {forgotLoading ? "Sending..." : "Send reset link"}
              </button>
              {forgotMsg && (
                <p style={{ fontSize: 13, color: "var(--text2)", marginTop: 8, lineHeight: 1.4 }}>
                  {forgotMsg}
                </p>
              )}
              <button
                type="button"
                onClick={() => setShowForgot(false)}
                style={{
                  width: "100%",
                  marginTop: 6,
                  background: "none",
                  border: "none",
                  color: "var(--text3)",
                  fontSize: 12,
                  cursor: "pointer",
                }}
              >
                Back to login
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
